<template lang="pug">
BriqTable
  thead
    th Date
    th Category
    th Action 
    th Result
    th Source
    th User Name
    th 
  tbody
    template(v-for="item in logData")
      tr.audit-trail-data-col(@click="item.showDetals = !item.showDetals")
        td {{ prettyDate(item.InsertDateUtc) }}
        td {{ item.Category }}
        td {{ item.Action }}
        td {{ item.Result }}
        td {{ item.Source }}
        td {{ item.UserName }}
        td
          .show-detals-btn(:class="item.showDetals ? `rotate-180` : ``")
            BriqIcon(name="icon-input-arrow-down-icon")
      tr(v-if="item.showDetals")
        td(colspan="6") 
          .logs-details-table
            BriqTable
              thead
                th Message
              tbody
                tr
                  td {{ item.Message }}             
</template>

<script>
import logTablesMixin from './logTablesMixin.js'

export default {
  name: 'TimeslotProvenance',
  mixins: [logTablesMixin],
  props: {
    logData: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/components-global/BriqViewAuditTrail/tableStyle.styl'
</style>
